import { FETCH_MOST_ENGAGED_COMMITTEES } from '../actions';

export default ( state = [], action ) => {
	switch ( action.type ) {

		case FETCH_MOST_ENGAGED_COMMITTEES:
			let engagedCommittees = [];
			engagedCommittees = Object.keys( action.payload )
			                          .map( value => value );
			return engagedCommittees;

	}

	return state;
}


